/*
	FILE SYSTEM
*/
//------------------------------------------------------------
// CLASS EXPORT
//------------------------------------------------------------

export default class FileSystem {
	constructor(data) {
		let paths = [];
		this._setPaths(data, paths);
		this.data = data;
		return data;
	}

	//------------------------------------------------------------
	// PREPARE NODES (RECURSIVE)
	// Traverse nodes and set their paths using name & heirarchy.
	//------------------------------------------------------------

	_setPaths(node, paths) {
		// create local copy so not to mutate the parent callers "path" state.
		paths = [...paths];

		// reassign '0.0.0.0' with '/'
		const path = paths.length === 0 ? '/' : node.name;

		paths.push(path);

		// store path on node. Prevent eg. '//Desktop'
		node.path = path === '/' ? paths.join('/') : paths.join('/').slice(1);

		// loop through the children, look for the node with more children and recurse
		if (node.children) {
			node.children.forEach(childNode => this._setPaths(childNode, paths));
		}
	}
}

//------------------------------------------------------------
//
//------------------------------------------------------------
//===========================================
//
//===========================================